<template>
    <div class="toolbar">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'toolbar',
        props: [],
        data: () => ({

        })
    }
</script>

<style lang="scss" scoped>

</style>
